// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"ed0d14b5","634":"8f5876c1","743":"86b003ca","817":"80ee63b5"}[chunkId] + ".chunk.js";
};